import { TextBoxesContainer } from './TextBoxesContainer';

export default TextBoxesContainer;
